/////////////////////////////////////////////////////////////////////////////////////////////////////////
//  화일명 : homeBanners.ts
//  설명 : "이번 달 시책" 배너(광고성 카드) 예시 데이터 - HomePageU1(홈 화면 "이번 달 시책" 카드)과 LoginPage(로그인 화면
//        광고 카드)가 같은 목록을 쓰도록 공용으로 분리함.
//        현재는 DB/API 연결이 없는 목업(예시) 데이터임. 로그인 화면은 로그인 전(무인증) 화면이라, 나중에 실제 시책 데이터로
//        연결할 때는 "로그인 전에 공개해도 되는 정보인지"(수수료율/금액 등 영업 정보)를 먼저 정해야 함.
//  개발이력 : 2026.09.21  HomePageU1.tsx에서 분리
/////////////////////////////////////////////////////////////////////////////////////////////////////////
export interface HomeBanner {
  carrier: string; // 보험사
  title: string;   // 시책명
  sub: string;     // 부제(조건)
  rate: string;    // 강조 수치
  dday: string;    // 마감 D-Day
  grad: string;    // 카드 배경 그라데이션(CSS)
}

export const HOME_BANNERS: HomeBanner[] = [
  { carrier: '삼성화재', title: '장기보험 신계약 시책', sub: '월납 초회보험료의 최대 700%', rate: '700%', dday: 'D-11', grad: 'linear-gradient(135deg,#0ea5e9,#2563eb)' },
  { carrier: 'DB손보', title: '건강보험 특별 캠페인', sub: '3건 이상 체결 시 추가 100만원', rate: '+100만', dday: 'D-5', grad: 'linear-gradient(135deg,#f97316,#ef4444)' },
  { carrier: '현대해상', title: '운전자보험 판매 이벤트', sub: '상반기 최고 수수료율 적용', rate: '최대', dday: 'D-18', grad: 'linear-gradient(135deg,#10b981,#0f766e)' },
];
